import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FileManagerModule } from '@sendpulse/file-manager';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { LetDirective } from '@ngrx/component';

import { SpPipesModule } from '@common/pipes/pipes.module';
import { SpColorPickerModule } from '@components/sp-color-picker/src/sp-color-picker.module';

import { SpFileManagerComponent } from './sp-file-manager.component';
import { SpImagePreviewSingleComponent } from './sp-image-preview-single/sp-image-preview-single.component';
import { SpImagePreviewMultipleComponent } from './sp-image-preview-multiple/sp-image-preview-multiple.component';
import { SpFilePreviewComponent } from './sp-file-preview/sp-file-preview.component';
import { SpVideoPreviewComponent } from './sp-video-preview/sp-video-preview.component';
import { SpAudioPreviewComponent } from './sp-audio-preview/sp-audio-preview.component';
import { SpSetupImageDropdownComponent } from './sp-setup-image-dropdown/sp-setup-image-dropdown.component';
import { SpFilesSelectComponent } from '@components/sp-file-manager/src/sp-files-select/sp-files-select.component';
import { SpDefaultUploadButtonComponent } from '@components/sp-file-manager/src/sp-upload-buttons/sp-default-upload-button.component';
import { SpLinkUploadButtonComponent } from '@components/sp-file-manager/src/sp-upload-buttons/sp-link-upload-button.component';

const MODULES = [
    CommonModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FileManagerModule,
    BsDropdownModule,
    SpPipesModule,
    SpColorPickerModule,
    LetDirective,
    SpFilesSelectComponent,
    SpDefaultUploadButtonComponent,
    SpLinkUploadButtonComponent,
];

const COMPONENTS = [
    SpFileManagerComponent,
    SpImagePreviewSingleComponent,
    SpImagePreviewMultipleComponent,
    SpFilePreviewComponent,
    SpVideoPreviewComponent,
    SpAudioPreviewComponent,
    SpSetupImageDropdownComponent,
];

@NgModule({
    imports: [...MODULES, ...COMPONENTS],
    exports: [...COMPONENTS, SpDefaultUploadButtonComponent, SpLinkUploadButtonComponent, SpFilesSelectComponent],
})
export class SpFileManagerComponentModule {}
